module.exports = __webpack_public_path__ + "c7e181221ef4a4a8a8ed204883654ec4.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/cities-countries/Venice2.jpg
// module id = 3341
// module chunks = 0